import { Button, Grid, Menu, MenuItem, Typography, makeStyles } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Add, Delete, Edit, MoreVert } from '@material-ui/icons';
import { Circle } from '@mui/icons-material';
import CloseIcon from '@material-ui/icons/Close';
import Service from '../../apis/service';
import { ErrorToast, MultipleErrorToast, notifySuccess, secondsToMinute } from '../utils/Utils';
import { setFuels, setSelectedFuel, showProgress } from '../../redux/actions/DealershipActions';
import ZeroState from '../common/ZeroState';
import FuelIcon from '../../assets/FuelIcon';
import MultiSelectSearch from '../common/search/MultiSelectSearch';
import Modal from '../common/Modal';
import ConfirmationDialog from '../common/ConfirmationDialog';
import DeleteIcon from '../../assets/DeleteIcon';
import UploadButton from '../journey/UploadButton';
import Theme from '../ui/Theme';
import { apiEndpoints } from '../../constants/apiEndpoints';
import Image from '../common/Image';

const useStyles = makeStyles(() => ({
  heading: {
    width: '100%',
    height: '50px',
    background: '#f3f4f7',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0px 10px',
  },
  list: {
    margin: '20px 0px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    height: '60vh',
    overflowY: 'auto',
  },
  card: {
    background: '#f3f4f7',
    padding: '10px',
    width: '90%',
    borderRadius: '10px',
    cursor: 'pointer',
  },
  box: {
    fontSize: '12px',
    color: '#667085',
    fontWeight: '500',
    display: 'flex',
    gap: '5px',
    alignItems: 'center',
  },
  selectedItem: {
    border: '1px solid #BEB3FF',
    background: '#F4F3FF',
    padding: '10px',
    width: '90%',
    borderRadius: '10px',
    cursor: 'pointer',
  },
  add: {
    width: '40px',
    height: '40px',
    color: 'white',
    background: '#622FEE',
    border: '4px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '18px',
    cursor: 'pointer',
  },
  imageContainer: {
    width: '80px',
    height: '70px',
    borderRadius: '5px',
    overflow: 'hidden',
  },
  image: {
    width: '100%',
    height: '100%',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: '5px',
    width: '80%',
  },
  title: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  popupContainer: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  form: {
    height: '70vh',
    width: '97%',
    background: '#f3f4f7',
    overflowY: 'auto',
    padding: '15px 10px',
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
  },
  inputField: {
    width: '90%',
    padding: '15px 10px',
    borderRadius: '5px',
    border: '1px solid gray',
    outline: 'none',
    marginTop: '5px',
    background: 'transparent',
  },
  upload: {
    border: '1px solid gray',
    padding: '10px',
    marginTop: '5px',
    width: '90%',
    borderRadius: '5px',
  },
  required_field: {
    '&:after': {
      content: "' *'",
      color: '#F50000',
    },
  },
  btnUploadStyle: {
    height: '24px',
    background: Theme.palette.secondary.main,
    width: '100%',
    marginBottom: '10px',
    fontFamily: 'Montserrat',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '12px',
    lineHeight: '15px',
    textAlign: 'center',
    letterSpacing: '0.2px',
    color: Theme.palette.quad.main,
  },
}));

export default function Fuels() {
  const classes = useStyles();
  const dispatch = useDispatch();

  const subCategorySelected = useSelector((state) => state.rockedFuelData.selectedSubCategory);
  const fuelSelected = useSelector((state) => state.rockedFuelData.selectedFuel);
  const fuels = useSelector((state) => state.rockedFuelData.fuels);

  const [isAddPopupOpen, setIsAddPopupOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [idToDelete, setIdToDelete] = useState(null);
  const [isOpenConfirmPopup, setIsOpenConfirmPopup] = useState(false);
  const [fuelName, setFuelName] = useState('');
  const [imageData, setImageData] = useState();
  const [thumbnail, setThumbnail] = useState('');
  const [relatedJourney, setRelatedJourney] = useState([]);
  const [relatedDepartment, setRelatedDepartment] = useState('');
  const [journey, setJourney] = useState([]);
  const [department, setDepartment] = useState([]);
  const journeyList = journey?.map((j) => ({
    value: j.id,
    label: j.title,
  }));
  const [isEdit, setIsEdit] = useState(false);
  const [selectedFuelIndex, setSelectedFuelIndex] = useState(0);

  const handleClick = (event, id) => {
    setAnchorEl(event.currentTarget);
    setIdToDelete(id);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const getJourney = async () => {
    dispatch(showProgress(true));
    try {
      const res = await Service.get(apiEndpoints.GET_JOURNEYS);
      setJourney(res);
    } catch (error) {
      ErrorToast(error);
    }
    dispatch(showProgress(false));
  };

  const getDepartment = async () => {
    dispatch(showProgress(true));
    try {
      const res = await Service.get(apiEndpoints.FUEL_DEPARTMENTS);
      setDepartment(res);
      if (res.length > 0) {
        setRelatedDepartment(res[0].id);
      }
    } catch (error) {
      ErrorToast(error);
    }
    dispatch(showProgress(false));
  };

  useEffect(() => {
    getJourney();
    getDepartment();
  }, []);

  const getFuelById = async () => {
    dispatch(showProgress(true));
    try {
      const res = await Service.get(apiEndpoints.FUEL_BY_ID.replace('ID', fuelSelected?.id));
      setFuelName(res?.title);
      setThumbnail(res?.thumbnail);
      setRelatedDepartment(res?.departmentId);
      const relatedJids = res?.relatedJourneys;
      const temp = journeyList?.filter((j) => relatedJids.includes(j.value));
      setRelatedJourney(temp);
    } catch (error) {
      ErrorToast(error);
    }
    dispatch(showProgress(false));
  };

  useEffect(() => {
    if (isEdit) {
      getFuelById();
    } else {
      clearState();
    }
  }, [isEdit]);

  const handleDeleteFuel = async () => {
    dispatch(showProgress(true));
    try {
      await Service.delete(apiEndpoints.FUEL_BY_ID.replace('ID', idToDelete));
      setIsOpenConfirmPopup(false);
      setAnchorEl(null);
      notifySuccess('Fuel Deleted Successfully');
      getFuels();
    } catch (error) {
      ErrorToast(error);
    }
    dispatch(showProgress(false));
  };

  const getFuels = async (index = 0) => {
    dispatch(showProgress(true));
    try {
      const res = await Service.get(apiEndpoints.FUEL_FETCH.replace('ID', subCategorySelected?.id));
      dispatch(setFuels(res));
      handleListItemClick(res[index]);
    } catch (error) {
      ErrorToast(error);
    }
    dispatch(showProgress(false));
  };

  useEffect(() => {
    if (subCategorySelected?.id) {
      getFuels();
    }
  }, [subCategorySelected]);

  const handleListItemClick = async (data = {}) => {
    dispatch(showProgress(true));
    dispatch(setSelectedFuel(data));
    dispatch(showProgress(false));
  };

  const handleFuelClick = (data, ind) => {
    handleListItemClick(data);
    setSelectedFuelIndex(ind);
  };

  const handleImageChange = (e) => {
    const filesData = e.target.files[0];
    setImageData(filesData);
    const reader = new global.FileReader();
    reader.onload = (ev) => {
      setThumbnail(ev.target.result);
    };
    reader.readAsDataURL(e.target.files[0]);
  };

  const handleJourneyChange = (value) => {
    if (value.length >= journey.length) {
      value.splice(0, 1);
    }
    setRelatedJourney(value);
  };

  const handleFuelEdit = async () => {
    setIsAddPopupOpen(true);
    setIsEdit(true);
    setAnchorEl(null);
  };

  const handleEditPopup = () => {
    setIsOpenConfirmPopup(true);
    setAnchorEl(null);
  };

  const handleValidation = () => {
    let isCorrect = true;
    const errors = [];

    if (!fuelName) {
      isCorrect = false;
      errors.push('Please enter Fuel Name.');
    }
    if (!relatedDepartment) {
      isCorrect = false;
      errors.push('Please select related department');
    }

    if (relatedJourney?.length === 0) {
      isCorrect = false;
      errors.push('Please select related journey');
    }

    if (!thumbnail) {
      isCorrect = false;
      errors.push('Please add a thumbail');
    }
    if (errors.length !== 0) {
      MultipleErrorToast(errors);
    }
    return isCorrect;
  };

  const clearState = () => {
    setFuelName('');
    setThumbnail('');
    setImageData();
    setRelatedJourney([]);
    setRelatedDepartment(department[0]?.id);
    setIsEdit(false);
  };

  const handleFuel = async () => {
    const isValidated = handleValidation();
    if (!isValidated) return;
    dispatch(showProgress(true));
    if (!isEdit) {
      const datas = new global.FormData();
      datas.append('title', fuelName);
      datas.append('departmentId', relatedDepartment);
      datas.append('fuelSubCategoryId', subCategorySelected?.id);
      datas.append('thumbnail', imageData);
      relatedJourney?.map((j) => datas.append('relatedJourneys', String(j.value)));

      try {
        await Service.post(apiEndpoints.FUEL_CREATE, datas);
        getFuels();
        setIsAddPopupOpen(false);
        notifySuccess('Fuel created successfully');
        clearState();
      } catch (error) {
        ErrorToast(error);
      }
    } else {
      const data = new global.FormData();
      data.append('title', fuelName);
      data.append('departmentId', relatedDepartment);
      data.append('fuelSubCategoryId', subCategorySelected?.id);
      if (imageData) {
        data.append('thumbnail', imageData);
      }
      relatedJourney?.map((j) => data.append('relatedJourneys', String(j.value)));

      try {
        await Service.post(apiEndpoints.FUEL_UPDATE.replace('ID', fuelSelected?.id), data);
        getFuels(selectedFuelIndex);
        setIsAddPopupOpen(false);
        notifySuccess('Fuel updated successfully');
        setIsEdit(false);
      } catch (error) {
        ErrorToast(error);
      }
    }
    dispatch(showProgress(false));
  };

  const handleOpenAddFule = () => {
    setIsEdit(false);
    setIsAddPopupOpen(true);
  };

  const handleCancel = () => {
    clearState();
    setIsAddPopupOpen(false);
  };

  return (
    <Grid container>
      <Grid className={classes.heading}>
        <Typography variant="h6">Fuels</Typography>
        <Grid className={classes.add} onClick={handleOpenAddFule}>
          <Add />
        </Grid>
      </Grid>
      {fuels.length > 0 ? (
        <Grid className={classes.list}>
          {fuels?.map((data, ind) => (
            <Grid
              className={data.id === fuelSelected?.id ? classes.selectedItem : classes.card}
              key={data.id}
              onClick={() => handleFuelClick(data, ind)}
            >
              <Grid style={{ display: 'flex', gap: '10px' }}>
                <Grid className={classes.imageContainer}>
                  <Image src={data.thumbnail} alt="thumbnamil" className={classes.image} loading="lazy" />
                </Grid>
                <Grid className={classes.content}>
                  <Grid className={classes.title}>
                    <Typography>{data.title}</Typography>
                    <div>
                      <MoreVert style={{ cursor: 'pointer' }} onClick={(e) => handleClick(e, data.id)} />
                    </div>
                  </Grid>
                  <Typography variant="p" className={classes.box}>
                    {data.activityTypes}{' '}
                    {data.activityTypes && data.duration && <Circle style={{ fontSize: '8px', color: 'gray' }} />}
                    {secondsToMinute(data.duration)}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          ))}

          <Menu
            id="simple-menu"
            keepMounted
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleClose}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
          >
            <MenuItem style={{ justifyContent: 'left' }} onClick={handleFuelEdit}>
              <Edit /> Edit Fuel
            </MenuItem>
            <MenuItem style={{ justifyContent: 'left' }} onClick={handleEditPopup}>
              <Delete /> Delete Fuel
            </MenuItem>
          </Menu>
        </Grid>
      ) : (
        <Grid className={classes.list}>
          <Grid item>
            <ZeroState
              Icon={FuelIcon}
              text="No fuels have been added in this topic"
              style={{
                marginTop: '20px',
              }}
              cardWidth="25vw"
            />
          </Grid>
        </Grid>
      )}
      {isAddPopupOpen && (
        <Modal isOpen={isAddPopupOpen} height="85vh" width="40vw">
          <Grid className={classes.popupContainer}>
            <Grid container direction="row" justifyContent="space-between" alignItems="flex-start">
              <Grid item>
                <Grid item style={{ fontWeight: '600', fontSize: '18px' }}>
                  {isEdit ? 'Edit Fuel' : 'Add Fuel'}
                </Grid>
              </Grid>
              <Grid item>
                <CloseIcon onClick={handleCancel} style={{ cursor: 'pointer' }} />
              </Grid>
            </Grid>
            <Grid className={classes.form}>
              <Grid>
                <Typography className={classes.required_field}>Fuel Name</Typography>
                <input
                  placeholder="ex: EV Roadtrip"
                  className={classes.inputField}
                  value={fuelName}
                  onChange={(e) => setFuelName(e.target.value)}
                />
              </Grid>

              <Grid>
                <Typography className={classes.required_field}>Thumbnail (max size - 100kb)</Typography>
                <Grid className={classes.upload}>
                  <Grid container direction="row" justifyContent="space-between" alignItems="center">
                    <Grid style={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
                      <Image alt="" src={thumbnail || ''} style={{ height: '26px' }} loading="lazy" />
                      <p>{imageData?.name}</p>
                    </Grid>
                    <Grid>
                      <UploadButton
                        disableElevation
                        className={classes.btnUploadStyle}
                        handleImageUpload={handleImageChange}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              <Grid>
                <Typography className={classes.required_field}>Related Journey</Typography>
                <Grid className={classes.upload}>
                  <MultiSelectSearch
                    placeholderButtonLabel="Select a Journey"
                    selectedOptions={relatedJourney}
                    onChange={handleJourneyChange}
                    options={journeyList || []}
                    width="100%"
                    maxMenuHeight={150}
                    labelWidth="270px"
                  />
                </Grid>
              </Grid>

              <Grid>
                <Typography className={classes.required_field}>Department</Typography>
                <Grid className={classes.upload} style={{ padding: '0px', width: '93%' }}>
                  <select
                    name="department"
                    id="departmentId"
                    value={relatedDepartment}
                    onChange={(e) => setRelatedDepartment(e.target.value)}
                    style={{
                      width: '97%',
                      border: 'none',
                      padding: '10px',
                      background: 'transparent',
                      outline: 'none',
                    }}
                  >
                    {department?.map((dept) => (
                      <option value={dept.id}>{dept.title}</option>
                    ))}
                  </select>
                </Grid>
              </Grid>
            </Grid>
            <Grid container direction="row" justifyContent="flex-end" alignItems="center">
              <Button onClick={handleCancel} variant="outlined">
                Cancel
              </Button>
              <Button variant="contained" color="primary" style={{ marginLeft: '10px' }} onClick={handleFuel}>
                Save
              </Button>
            </Grid>
          </Grid>
        </Modal>
      )}
      <ConfirmationDialog
        title="Are you sure you want to delete this Fuel?"
        subText="Once you delete it, you will not be able to recover this fuel."
        onClose={setIsOpenConfirmPopup}
        isOpen={isOpenConfirmPopup}
        confirmFn={handleDeleteFuel}
        disagreeText="Cancel"
        agreeText="Delete"
        Icon={DeleteIcon}
        width="500px"
        height="250px"
      />
    </Grid>
  );
}
